import type { Uid } from "@/helpers/utility/Id";
import { defineItemStore } from "../itemStore.store";
import type { StoreItem } from "../StoreItem";

export interface SceneRelationSettingsItem extends StoreItem {
  type: "sceneRelationSetting";
  id: number;
  uid: Uid<"sceneRelationSetting">;

  relationId: number;
  sceneId: number;

  visible: boolean;
};

const defaultSceneRelationSetting: SceneRelationSettingsItem = {
  type: "sceneRelationSetting",
  id: 0,
  uid: "sceneRelationSetting_0",

  relationId: 0,
  sceneId: 0,

  visible: true,

  createdAt: -1
};

export const useSceneRelationSettingsStore = defineItemStore("model/sceneRelationSettings", defaultSceneRelationSetting, {
  getters: {
    byScene(state): { [sceneId: number]: Record<number, SceneRelationSettingsItem> } {
      const settings: { [sceneId: number]: Record<number, SceneRelationSettingsItem> } = {};
      for (const setting of Object.values(state.items)) {
        if (!settings[setting.sceneId]) {
          settings[setting.sceneId] = {};
        }
        settings[setting.sceneId][setting.relationId] = setting;
      }
      return settings;
    }
  },
  actions: {
    async updateOrCreate(data: Partial<SceneRelationSettingsItem> & { relationId: number; sceneId: number }) {
      const existing = this.byScene[data.sceneId]?.[data.relationId];
      if (existing) {
        return this.update({
          id: existing.id,
          ...data
        });
      }
      return this.create({
        ...defaultSceneRelationSetting,
        ...data
      });
    }
  }
});
